import { Dialog } from '@mui/material';
import { useIsPhone } from '../../hooks/useIsMobile';
import { useIsMobile } from '../../hooks/useIsMobile';

export default function MobileDialog({ open, children, ...props }) {
  const isPhone = useIsPhone();
  const isMobile = useIsMobile();

  return (
    <Dialog
      open={open}
      fullScreen={isPhone}
      maxWidth={isMobile && !isPhone ? 'md' : props.maxWidth}
      {...props}
      sx={{
        ...props.sx,
        ...(isMobile && !isPhone && {
          '& .MuiDialog-paper': {
            width: '95vw',
            maxHeight: '90vh',
            margin: '16px',
          },
        }),
      }}
    >
      {children}
    </Dialog>
  );
}